export default "__VITE_ASSET__DJH_$jcw__"